import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import './DGTextbox.less'
import loader from '../../../assets/images/newui/loader.gif'

/**
 * Textbox for dealgrace
 * @augments {Component<Props, State>}
 */
class DGTextbox extends Component {
    constructor(props) {
        super(props);
        this.inputRef = createRef();
    }
    componentDidMount() {

    }


    changeValue = (event, data) => {
        this.props.setValue(event.currentTarget.value);
        if (this.props.onChange) {
            this.props.onChange(event, { name: this.props.name, value: event.currentTarget.value });
        }
    };

    onKeyPress = (event) => {
        if (this.props.onKeyPress)
        {
            this.props.onKeyPress(event);
        }
    }
    onBlur = (e) => {
        if(this.props.onBlur)
        {
            this.props.onBlur(e);
        }
    }

    onFocus = () => {
        if(this.props.onFocus)
        {
            this.props.onFocus();
        }   
    }

    render() {

        let inputClassName = 'dgtext';
        let labelClassName = 'label';
        if(this.props.className)
        {
            inputClassName += ` ${this.props.className}`
        }
        if (this.props.icon) {
            inputClassName += ' icon';
            labelClassName += ' icon';
        }
        if ((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) {
            inputClassName += ' error';
        }
        return (
            <div className="field">
                {this.props.icon &&
                    <img src={this.props.icon} />
                }
                <input 
                    {...this.props}
                    onFocus={() => {this.onFocus()}} 
                    onBlur={(e) => { this.onBlur(e)}}  
                    type={this.props.type || 'text'} 
                    onChange={this.changeValue} 
                    ref={this.inputRef} 
                    maxLength={this.props.maxLength}
                    onKeyDown={this.props.onKeyDown}
                    onKeyPress={this.onKeyPress}
                    tabIndex={this.props.tabIndex}
                    {...{
                        placeholder: this.props.placeholder ? this.props.placeholder : " ",
                        className: inputClassName,
                        disabled: this.props.disabled
                    }}
                    value={this.props.value || ''}
                />
                <div className={labelClassName}><span>{this.props.label}</span>
                    {this.props.placeholder && <span> ({this.props.placeholder})</span>}
                    {!this.props.placeholder && <span></span>}
                </div>
                {((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) && <div className="error-label">{this.props.errorMessage || this.props.externalErrorMessage}</div>}
                {this.props.showRequired &&
                    <div className="required">*</div>
                }

                {this.props.showLoader &&
                    <div className="loader"><img src={loader}></img></div>
                }
            </div>
        )
    }
}

DGTextbox.propTypes = {
    // Parent props
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    type: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    disabled: PropTypes.bool,
    maxLength: PropTypes.number,
    tabIndex: PropTypes.number,

    errorMessage: PropTypes.string,
    externalErrorMessage: PropTypes.string,
    validExternally: PropTypes.bool,

    showRequired: PropTypes.bool,
    showLoader: PropTypes.bool,

    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyDown: PropTypes.func,

    // Formsy injected props
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    setValue: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    isPristine: PropTypes.bool,
    isFormSubmitted: PropTypes.bool
};

export default withFormsy(DGTextbox)
